const config = {
  local: {
    authority: "https://policebox-dev.css.rxweb-dev.com/secure",
    clientId: "PkceClientId",
    redirectUri: "http://localhost:4000/loggedin/",
    postLogoutRedirectUri: "http://localhost:4000/logout/",
    logoutInternalRedirect: "https://www.google.com",
    inactiveTimeoutInSeconds: 1800,
    activityEvents: ["keypress", "click"],
    usePkce: true,
    eventEditionId: ""
  },
  localAgainstShow: {
    loginUrl: "https://policebox-show.css.rxweb-dev.com/secure/connect/authorize",
    logoutUrl: "https://policebox-dev.css.rxweb-dev.com/secure/connect/endsession",
    authority: "https://policebox-show.css.rxweb-dev.com/secure",
    authorityUrl: "https://policebox-show.css.rxweb-dev.com/secure",
    clientId: "RX-AUTH-CL-Pkce01",
    redirectUri: "http://localhost:4000/loggedin.html",
    postLogoutRedirectUri: "http://localhost:4000/logout.html",
    inactiveTimeoutInSeconds: 1800,
    activityEvents: ["keypress", "click"],
    usePkce: true,
    eventEditionId: ""
  },
  dev: {
    authority: "https://policebox-dev.css.rxweb-dev.com/secure",
    clientId: "PkceClientId",
    redirectUri: "https://onsite-dev.rxweb-dev.com/authpcke",
    postLogoutRedirectUri: "https://onsite-dev.rxweb-dev.com/logout.html",
    logoutInternalRedirect: "https://www.google.com",
    inactiveTimeoutInSeconds: 1800,
    activityEvents: ["keypress", "click"],
    usePkce: true,
    eventEditionId: ""
  },
  show: {
    loginUrl: "https://policebox-show.css.rxweb-dev.com/secure/connect/authorize",
    authority: "https://policebox-show.css.rxweb-dev.com/secure",
    authorityUrl: "https://policebox-show.css.rxweb-dev.com/secure",
    clientId: "RX-AUTH-CL-Pkce01",
    redirectUri: "https://onsite-show.rxweb-pre.com/authpcke",
    postLogoutRedirectUri: "https://onsite-show.rxweb-pre.com/logout.html",
    inactiveTimeoutInSeconds: 1800,
    activityEvents: ["keypress", "click"],
    usePkce: true,
    eventEditionId: ""
  },
  preprod: {
    authority: "https://cdn-auth.reds.rxweb-pre.com/secure",
    clientId: "RX-AUTH-CL-Pkce01",
    redirectUri: "https://onsite-preprod.rxweb-pre.com/authpcke",
    postLogoutRedirectUri: "https://onsite-preprod.rxweb-pre.com/logout.html",
    inactiveTimeoutInSeconds: 1800,
    activityEvents: ["keypress", "click"],
    usePkce: true,
    eventEditionId: ""
  },
  prod: {
    authority: "https://auth.reedexpo.com/secure",
    clientId: "RX-AUTH-CL-Pkce01",
    redirectUri: "https://onsite.rxglobal.com/authpcke",
    postLogoutRedirectUri: "https://onsite.rxglobal.com/logout.html",
    inactiveTimeoutInSeconds: 1800,
    activityEvents: ["keypress", "click"],
    usePkce: true,
    eventEditionId: ""
  }
};

// @ts-ignore
const getConfig = env => (env && config[env] ? config[env] : null);

const authConfig = {
  getConfig,
  config
};

export default authConfig;
